// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = "#1DA1F2";
export const facebookColor = "#3b5998";
export const linkedInColor = "#0e76a8";

export const APP_DEFAULT_PATH = "/home";
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 248;
export const MINI_DRAWER_WIDTH = 90;
export const HEADER_HEIGHT = 104;

/** Desktop drawer inset — floats inside the page (not edge-flush) */
export const DRAWER_INSET = {
  top: 12,
  bottom: 12,
  left: 12,
};
export const DRAWER_SLOT_WIDTH = DRAWER_WIDTH + DRAWER_INSET.left;
export const MINI_DRAWER_SLOT_WIDTH = MINI_DRAWER_WIDTH + DRAWER_INSET.left;

export let SimpleLayoutType;

(function (SimpleLayoutType) {
  SimpleLayoutType["SIMPLE"] = "simple";
  SimpleLayoutType["LANDING"] = "landing";
})(SimpleLayoutType || (SimpleLayoutType = {}));

export let ThemeMode;

(function (ThemeMode) {
  ThemeMode["LIGHT"] = "light";
  ThemeMode["DARK"] = "dark";
  ThemeMode["AUTO"] = "auto";
})(ThemeMode || (ThemeMode = {}));

export let MenuOrientation;

(function (MenuOrientation) {
  MenuOrientation["VERTICAL"] = "vertical";
  MenuOrientation["HORIZONTAL"] = "horizontal";
})(MenuOrientation || (MenuOrientation = {}));

export let ThemeDirection;

(function (ThemeDirection) {
  ThemeDirection["LTR"] = "ltr";
  ThemeDirection["RTL"] = "rtl";
})(ThemeDirection || (ThemeDirection = {}));

export let NavActionType;

(function (NavActionType) {
  NavActionType["FUNCTION"] = "function";
  NavActionType["LINK"] = "link";
})(NavActionType || (NavActionType = {}));

export let Gender;

(function (Gender) {
  Gender["MALE"] = "Male";
  Gender["FEMALE"] = "Female";
})(Gender || (Gender = {}));

export let DropzopType;

(function (DropzopType) {
  DropzopType["DEFAULT"] = "default";
  DropzopType["STANDARD"] = "standard";
})(DropzopType || (DropzopType = {}));

// ==============================|| THEME CONFIG ||============================== //

const config = {
  fontFamily: `Inter var`,
  i18n: "fr",
  menuOrientation: MenuOrientation.VERTICAL,
  menuCaption: true,
  miniDrawer: false,
  container: false,
  mode: ThemeMode.LIGHT,
  presetColor: "default",
  themeDirection: ThemeDirection.LTR,
  themeContrast: false,
};

export default config;
